import { makeStyles } from '@fluentui/react-components';

export const fieldPikerStyles = makeStyles({
  label: {
    padding: '20px',
    cursor: 'pointer',
    borderRadius: '8px',
    transition: 'border-color 0.2s',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '0.8rem',
    gap: '4px',
    border: '1px dashed #B3B3B3',

    ':focus': {
      border: '1px solid var(--colorStrokeFocus2)',
      outline: 'var(--strokeWidthThik) solid var(--colorTransparentStroke)',
      boxShadow: '0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset',
    },
  },

  draggingBorder: {
    border: '2px dashed #1d39c4',
  },

  draggingLabel: {
    color: '#1d39c4',
    fontWeight: 600,
  },

  blueText: {
    fontWeight: 600,
    color: '#1d39c4',
  },
  strong: {
    fontWeight: 600,
  },

  fileList: {
    padding: '20px',
    backgroundColor: '#fafafa',
    borderRadius: '12px',
  },

  fileListHeader: {
    marginBottom: '8px',
    fontWeight: '600',
    fontSize: '14px',
    color: '#333',
  },

  fileItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'all 0.2s ease',
    borderRadius: '4px',

    ':hover': {
      backgroundColor: '#f0f0f0',
    },
  },

  fileNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
    minWidth: 0,
  },

  fileName: {
    fontSize: '14px',
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  fileActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
});
